module.exports = __webpack_public_path__ + "img/about_banner.dc4083aa.png";